import { TsDOM as q } from '@/scripts/core/TsDOM'
import { GorgiasHelpCenter } from '@/scripts/theme/gorgias-help-center'

q.safeDefineElement(GorgiasHelpCenter)
